import { Injectable, NgZone } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class MessageService {
  private port: chrome.runtime.Port | null = null;

  constructor(private ngZone: NgZone) {
    this.connect();
  }

  private connect(): void {
    try {
      this.port = chrome.runtime.connect({ name: 'admin2.0' });

      this.port.onDisconnect.addListener(() => {
        // Run inside Angular's zone to trigger change detection
        this.ngZone.run(() => {
          console.log('Port disconnected. Attempting to reconnect...');
          this.port = null;
          // You might want to add a delay before reconnecting to prevent a loop
          setTimeout(() => this.connect(), 1000);
        });
      });
    } catch (error) {
      console.error('Could not connect to extension background script:', error);
      this.port = null;
    }
  }

  sendMessage(message: string): void {
    if (this.port) {
      this.port.postMessage(message);
    } else {
      console.warn(
        'Port not connected. Attempting to reconnect and send message.',
      );
      this.connect();
      // Optionally, retry sending the message after a delay
      // setTimeout(() => {
      //   if (this.port) {
      //     this.port.postMessage(message);
      //   }
      // }, 50);
    }
  }
}
